export default __webpack_public_path__ + "8967cd5be94f393d5015311bf960e25c.png";